import { seasonRepository, teamRepository } from "../../storage/storage";
import NotImplemented from "../../exceptions/not-implemented";
import { camelToUnderscore } from "../common/object-util";

class BaseImporter {
    mapCsvPlayers() {
        throw new NotImplemented();
    }

    validateRecords() {
        throw new NotImplemented();
    }

    getRequiredHeaders() {
        throw new NotImplemented();
    }

    getOptionalHeaders() {
        throw new NotImplemented();
    }

    generateHeaders() {
        return [...this.getRequiredHeaders(), ...this.getOptionalHeaders()]
            .map(camelToUnderscore)
            .join(",");
    }

    isEmpty(obj, field) {
        return !obj[field];
    }

    matches(obj, field, regex) {
        return regex.test(obj[field]);
    }

    validateHeader(meta) {
        const errors = [];
        const requiredHeaders =
            this.getRequiredHeaders().map(camelToUnderscore);
        const optionalHeaders =
            this.getOptionalHeaders().map(camelToUnderscore);
        if (!requiredHeaders.every((rh) => meta.fields.includes(rh))) {
            errors.push(
                `Header is missing or invalid. Valid headers are: ${[
                    ...requiredHeaders,
                    ...optionalHeaders.map((h) => `${h} (optional)`)
                ]
                    .map(camelToUnderscore)
                    .join(", ")}`
            );
        }

        return errors;
    }

    isFieldDuplicated(importedRecords, importedPlayer, fieldName) {
        return (
            importedRecords.filter(
                (r) => r[fieldName] === importedPlayer[fieldName]
            ).length > 1
        );
    }

    async importPlayers(teamId, importResult) {
        const { data, meta } = importResult;
        const team = await teamRepository.getById(teamId);
        const { seasonId } = team;
        const { sport } = await seasonRepository.getBySeasonId(seasonId);

        const importedPlayers = await this.mapCsvPlayers(
            teamId,
            sport.sportId,
            data
        );

        const importErrors = this.validateHeader(meta);

        if (importedPlayers.length) {
            this.validateRecords(importedPlayers);
        } else {
            importErrors.push("Import file is empty");
        }

        return { importedPlayers, importErrors };
    }

    readCsvValue(record, fieldName) {
        return record[camelToUnderscore(fieldName)];
    }
}

export default BaseImporter;
